<template>
  <v-app style="height: 100%; max-width: 450px"
    :class="{on_desktop: $vuetify.breakpoint.smAndUp}"
  >
    <v-main class="grey lighten-3">
      <slot>
        <router-view />
      </slot>
    </v-main>
  </v-app>
</template>
<script>


export default {
  name: 'EmptyLayout',
}
</script>
